module.exports = __webpack_public_path__ + "assets/img/5_1179_big.20fa5610.jpg";